import React, { type FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import {
  FetchCompaniesAction,
  FetchUnassignedUsersAction,
  SearchCompaniesAction
} from '../../../redux/admin/admin-companies-actions'
import { SearchBar } from '../../common/search-bar/SearchBar'
import { CustomersDetails } from './CustomersDetails'
import { CustomersList } from './CustomersList'
import { CompanyFormContainer, CustomersViewContainer } from './CustomersView.style'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { type RootState } from '../../../redux/store'
import { type AdminCompany, type SelectedOrganization } from '../../../redux/admin/admin-companies-types'

/**
 * Customer management view (for admins).
 */
export const CustomersView: FC = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const companies = useAppSelector<AdminCompany[]>((state: RootState) => state.admin.companies)
  const unassignedUsersLoaded = useAppSelector<boolean>((state: RootState) => state.admin.unassignedUsersLoaded)
  const editedOrganization = useAppSelector<SelectedOrganization | null>((state: RootState) => state.admin.editCompanyDialog.selectedOrganization)

  useEffect(() => {
    dispatch(FetchCompaniesAction())
  }, [dispatch])

  useEffect(() => {
    if (!unassignedUsersLoaded) {
      dispatch(FetchUnassignedUsersAction())
    }
  }, [dispatch, unassignedUsersLoaded])

  const searchValue = useAppSelector<string>(state => state.admin.searchText)

  const onSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    dispatch(SearchCompaniesAction({
      searchText: e.target.value,
      searchCompanies: companies
    }))
  }

  return (
        <CustomersViewContainer>
            <div>
                <p>{t('customers')}</p>
                <SearchBar onChange={onSearchTextChange} searchValue={searchValue}/>
            </div>
            <CompanyFormContainer>
                <CustomersList/>
                {editedOrganization != null && <CustomersDetails selectedOrganization={editedOrganization}/>}
            </CompanyFormContainer>
        </CustomersViewContainer>
  )
}
